import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import MenuCategoriesTable from './menuCategoriesTable';
import { connect } from 'react-redux';
import Pagination2 from '../../components/Pagination2';
import * as menuCategoriesActions from '../../redux/menuCategories/actions';
import AddMenuCategories from './modals/insertNewMenuCategory';
import Spin from '../../components/loading';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

class MenuCategories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      errorText: locales('errors.default'),
      errorFlag: false,
      itemsPerPage: 10,
      addMenuCategoriesOpen: false,
      selectedMenuCategoryId: null
    };
  }
  componentDidMount() {
    this.props.fetchAllMenuCategories(
      `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`
    );
  }
  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };
  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      console.log('pageNumber is: ', pageNumber);
      console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    console.log('pagination data: ', data);

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllMenuCategories(query);
    });
  };

  closeMenuCategoriesModal = () => {
    this.props
      .fetchAllMenuCategories(`pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`)
      .then(() => {
        this.setState(() => ({
          addMenuCategoriesOpen: false
        }));
      });
  };

  displayAddMenuCategoriesModal = () => {
    this.setState({ addMenuCategoriesOpen: true });
  };

  render() {
    let { loading, message, failed, error } = this.props;
    let { totalRecords } = this.props.menuCategories;
    let { currentPage, itemsPerPage } = this.state;
    return (
      <>
        {this.state.errorFlag && this.handleAlert()}
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.cafeMenuCategories')}</div>
          </h3>
          <div>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_DELETED_MENU_CATEGORIES_LIST}>
              <Link to="/menu-categories-deleteds">
                <button className="btn btn-secondary w-5 mx-1">
                  <i className="fa fa-times" />
                  {locales('labels.deleteds')}
                </button>
              </Link>
            </ShowForPermission>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_MENU_CATEGORY}>
              <button
                onClick={() => this.displayAddMenuCategoriesModal()}
                className="btn btn-primary w-5 mx-1"
              >
                <i className="fal fa-plus mx-1" />
                {locales('labels.new')}
              </button>
            </ShowForPermission>
          </div>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={loading}>
            <article>
              <main className="panel panel-default">
                {error ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {failed && <div className="alert alert-danger">{message}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.menuCategories')}
                    </div>
                    <div className="panel-body">
                      <React.Fragment>
                        <MenuCategoriesTable pageNumber={currentPage} pageSize={itemsPerPage} />
                        <footer className="col-12 d-flex justify-content-center py-2">
                          <div className="pagination-container">
                            <Pagination2
                              totalRecords={totalRecords || 0}
                              pageLimit={itemsPerPage}
                              pageNeighbours={2}
                              onPageChanged={this.onPageChanged}
                              currentPage={this.state.currentPage}
                            />
                          </div>
                        </footer>
                      </React.Fragment>
                      {this.state.addMenuCategoriesOpen && (
                        <AddMenuCategories
                          isOpen={this.state.addMenuCategoriesOpen}
                          closeModal={this.closeMenuCategoriesModal}
                        />
                      )}
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    cafeName: state.authReducer.meInfo.selectedRole.cafeName,
    loading: state.menuCategoriesReducer.menuCategoriesLoading,
    message: state.menuCategoriesReducer.menuCategoriesMessage,
    failed: state.menuCategoriesReducer.menuCategoriesFailed,
    error: state.menuCategoriesReducer.menuCategoriesError,
    menuCategoriesList: state.menuCategoriesReducer.menuCategoriesList,
    menuCategories: state.menuCategoriesReducer.menuCategories
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllMenuCategories: query => dispatch(menuCategoriesActions.fetchAllMenuCategories(query))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MenuCategories)
);
